// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__zTvGN","title":"Info_title__14IwB","links":"Info_links__1s89p","link":"Info_link__2JHoY","logo":"Info_logo__ey0WF"};